class CelebrationModalService {
  private showModalFn: ((data: any) => void) | null = null;
  private hideModalFn: (() => void) | null = null;

  init(showFn: (data: any) => void, hideFn: () => void) {
    this.showModalFn = showFn;
    this.hideModalFn = hideFn;
  }

  show(data: {
    header: string;
    headerIcon?: string;
    subtitle: string;
    image: string;
    description: string;
    subDescription?: string;
    buttonText: string;
    showConfetti?: boolean;
    onButtonClick?: () => void;
  }) {
    if (this.showModalFn) {
      this.showModalFn(data);
    }
  }

  hide() {
    if (this.hideModalFn) {
      this.hideModalFn();
    }
  }
}

export const celebrationModalService = new CelebrationModalService();
